<template>
  <div>
    <h3 class="align_left">
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Paramètres généraux des parcours
    </h3>
    <div class="align_left">
      <b-form-checkbox v-model="$store.state.admin.allow_gpx_download" name="check-button" button size="sm" value="1" unchecked-value="0"> Autoriser le téléchargement des GPX </b-form-checkbox>
    </div>

    <div class="sep"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>